export default __webpack_public_path__ + "static/media/icono-redireccion.c79e5f92.svg";